import { useIonToast } from "@ionic/react";
import { alertCircle, checkmarkCircle } from "ionicons/icons";
import { Haptics, NotificationType } from "@capacitor/haptics";

function useUX() {
    const [presentToast] = useIonToast();

    async function presentResult(fn: Function, successMessage?: string) {
        try {
            await fn();

            if (successMessage) {
                Haptics.notification({ type: NotificationType.Success }).catch(e => e);

                await presentToast({
                    message: successMessage,
                    duration: 2500,
                    color: 'success',
                    icon: checkmarkCircle
                });
            }
        } catch (e: any) {
            Haptics.notification({ type: NotificationType.Error }).catch(e => e);
            await presentToast({
                message: e.message,
                duration: 2500,
                color: 'danger',
                icon: alertCircle
            });
        }
    }

    return {
        presentResult
    }
}

export default useUX;
